window.addEventListener('scroll', function () {
  const check = window.pageYOffset;  // 現在のスクロール位置を取得
  const docHeight = document.documentElement.scrollHeight;  // ページ全体の高さを取得
  const dispHeight = window.innerHeight;  // 表示されている高さを取得

  const topStics = document.querySelectorAll('.top_stic');
  const searchStics = document.querySelectorAll('.search_stic');
  const fade_duration = 500;
  const top_offset = 200;
  const bottom_offset = 200


  // ページ下部に近づいた場合の判定を先に行う
  if (check > docHeight - dispHeight - bottom_offset) {
    // ページ下部近くの場合はフェードアウト
    fadeOut(topStics, fade_duration);
    fadeOut(searchStics, fade_duration);
  } else if (check > top_offset) {
    // 100pxを超えたら .top_stic を表示してフェードイン
    topStics.forEach(el => {
      el.style.display = 'grid'; // 各要素に display を設定
    });
    searchStics.forEach(el => {
      el.style.display = 'block'; // 各要素に display を設定
    });
    fadeIn(topStics, fade_duration);
  } else if (check <= top_offset) {
    fadeOut(topStics, 500);
  }
});

function fadeOut(elements, duration) {
  $(elements).each(function () {
    $(this).fadeOut(duration, function () {
      $(this).css('display', 'none');  // フェードアウト後に display: none を設定
    });
  });
}

function fadeIn(elements, duration) {
  $(elements).each(function () {
    $(this).fadeIn(duration);
  });
}



$(function () {

  $('#header').load('/inc/header.html', function () {
    $('a[href^="#"]').click(function () {
      var adjust = $('.smenu').outerHeight() + 50;
      var speed = 400;
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top - adjust;
      $('body,html').animate({scrollTop: position}, speed, 'swing');
      return false;
    });
  });
  $('#footer').load('/inc/footer.html', function () {
    $('a[href^="#"]').click(function () {
      var adjust = $('.smenu').outerHeight() + 50;
      var speed = 400;
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top - adjust;
      $('body,html').animate({scrollTop: position}, speed, 'swing');
      return false;
    });
  });

});


/*Dropdown Menu*/
$('.dropdown').click(function () {
  $(this).attr('tabindex', 1).focus();
  $(this).toggleClass('active');
  $(this).find('.dropdown-menu').slideToggle(300);
});
$('.dropdown').focusout(function () {
  $(this).removeClass('active');
  setTimeout(() => {
    $(this).find('.dropdown-menu').slideUp(300);
  }, 300)
});
$('.dropdown .dropdown-menu li').click(function () {
  $(this).parents('.dropdown').find('span').text($(this).text());
  $(this).parents('.dropdown').find('input').attr('value', $(this).attr('id'));
});
/*End Dropdown Menu*/

$(window).on('load', function () {

  $(function () {
    $('a[href^="#"]').click(function () {

      var adjust = $('.smenu').outerHeight() + 50;
      var speed = 400;
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top - adjust;
      //進行中のアニメーションを停止して、新たなスクロールを開始
      $('body,html').stop(true, true).animate({scrollTop: position}, speed, 'swing');
      return false;
    });
  });
});


/**
 * お気に入りボタン
 */
import FavoriteButton from '../lib/favorite/favoriteButton';
import Favorite from '../lib/favorite/favorite';

!function () {
  // お気に入りボタンを取得
  const buttons = document.querySelectorAll('[data-bookmark-button]');
  if (buttons.length == 0) return;

  (async () => {
    // お気に入り登録した物件を取得
    const response = await Favorite.getOfficeIds();

    // お気に入りボタンの初期化
    buttons.forEach(button => {
      new FavoriteButton(button, response.data.data);
    });
  })()
}();
